import axios from 'axios';

export async function deleteFile(filelink:any) {
    return await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/delete/${filelink}`);
}

export async function checkFileSharing(filelink:any, data:any) {
    return await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/sharingCheck/${filelink}`, {uid : data});
}

// export async function getFileListByRoom(type:any, uid:number, roomId:any, tabNumber:any)  {
//     // return await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/user/file/${roomId}/${uid}?tab=${tabNumber}`);
//     return await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/${roomId}/${uid}/${tabNumber}?type=${type}`);
// }
export async function getFileListByRoom(type:any, uid:number, roomId:any)  {
    return await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/${roomId}/${uid}?type=${type}`);
}
export async function uploadFileByGroup(dataToSubmit: any, group: number, uid:number,  roomId:number,config :any)  {
    return await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/user/file/upload?uid=${uid}&group=${group}&roomId=${roomId}`, dataToSubmit, config);
}

export async function getRoomUserList(roomId:Number, uid:Number)  {
    return await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/list/${roomId}/${uid}`);
}

export async function shareFile(fid:number, userList:any, roomId:any)  {
    return await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/share?fid=${fid}&userList=${userList}&roomId=${roomId}`);
}

export const getDownloadURL = (filepath: any, filelink:any) => {
    return `${process.env.REACT_APP_SERVER_BASE_URL}/user/file/download/${filepath}/${filelink}`;
}

export const getDownloadThumbnailURL = (filepath: any, filelink:any) => {
    return `${process.env.REACT_APP_SERVER_BASE_URL}/user/file/thumbnail/${filepath}/${filelink}`;
}

export const getCampusDownloadURL = (filelink:any, type:any) => {
    return `${process.env.REACT_APP_SERVER_BASE_URL}/campus/user/file/download/${filelink}?type=${type}`;
}

export const getProfileDownloadURL = (filelink:any) => {
    return `${process.env.REACT_APP_SERVER_BASE_URL}/${filelink}`;
}